var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 144C176 99.8 211.8 64 256 64C287.9 64 315.4 82.6 328.3 109.7C335.9 125.7 355 132.5 370.9 124.9C386.8 117.3 393.7 98.2 386.1 82.3C363 33.7 313.5 0 256 0C176.5 0 112 64.5 112 144V192H96C60.7 192 32 220.7 32 256V448C32 483.3 60.7 512 96 512H416C451.3 512 480 483.3 480 448V256C480 220.7 451.3 192 416 192H176V144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.c41bea2c4ec12a12ddfc9e3d38e600b5.svg";
export { ForwardRef as ReactComponent };